const ga_ids = {
  'preorder_success': 'preorder_success',
  'preorder_update_success': 'preorder_update_success',
}

export default ga_ids;
